/* import __COLOCATED_TEMPLATE__ from './walkthrough-popover.hbs'; */
import Component from '@ember/component';

/**
## Walkthrough Popover

A green popover for walkthroughs that displays progress and buttons for going to next steps.
For information on how to create walkthroughs in Dashboard, check out the
[Walkthrough Popover Guide](/development/walkthrough.html).

### Example Usage

```handlebars
{{walkthrough-popover popoverClassNames="popover--fly-down popover--align-right pointer--top pointer--align-right"
                                  isActive=walkthrough.isActive
                                  step=currentStep
                                  progressText="1/2"
                                  next=(action "next")}}
```

### Parameters
@param {string} popoverClassNames  - class names for the component
@param {boolean} isActive - if the popover is active
@param {Object} step - the WalkthroughStep the popover is showing
@param {string} progressText - string displaying current step number out of total
@param {action} next - action for button click
@param {action} close - action for when "X" close button click. If not present, the "X" button will not show

Sass dependencies at: `@square/glass-ui/addon/styles/@square/dialog/walkthrough/_walkthrough.scss`
*/

// See models/walkthrough.js for documentation

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  step: null,
  isActive: null,
  progressText: null
});